import { Target } from "react-feather";
import axiosInstance from "./AxiosInstance";

export function getCampaigns(
  pagination,
  pageid,
  search_by = "",
  search_keyword = "",
  sort_by = "",
  sort_order = ""
) {
  return axiosInstance.post("campaigns/list", {
    pagination,
    pageid,
    search_by,
    search_keyword,
    sort_by,
    sort_order,
  });
}

export function createCampaign(campaignData) {
  return axiosInstance.post("campaigns/add", campaignData);
}

export function getCampaignsByDate(target_date) {
  return axiosInstance.post("campaigns/getByDate", {
    target_date,
    
  });
}
export function updateCampaign(campaignData) {
  return axiosInstance.post("campaigns/edit", {
    ...campaignData,
  });
}

export function deleteCampaign(campaign_id) {
  return axiosInstance.post("campaigns/delete", {
    campaign_id:campaign_id,
  });
}

export function formatCampaigns(data) {
  if (!Array.isArray(data)) return [];

  return data.map((item) => ({
    campaign_id: item.campaign_id,
    title: item.title,
    consultation_charges: item.consultation_charges,
    medicinal_discount: item.medicinal_discount,
    start_date: item.start_date,
    end_date: item.end_date,
    description: item.description,
    campaign_status: item.campaign_status,
  }));
}

